import React from "react";
import { createPortal } from "react-dom";
import styles from './loading.module.css'
import Logo from '../../../logo.svg'

const Loading = ({ fullPage = false, fullAccount = false, initialLoad = false }) => {
    const shouldUseViewport = fullPage || fullAccount
    const content = (
        <div className={`${initialLoad ? styles.initialLoading : styles.loading} ${shouldUseViewport ? styles.fullPage : ''}`}>
            <img src={Logo} alt="Logo Oktto" />
            {initialLoad && <span>Carregando...</span>}
        </div>
    )

    if (shouldUseViewport && typeof document !== "undefined") {
        return createPortal(content, document.body)
    }

    return content
}

export default Loading
